import { createApiRef } from '@backstage/frontend-plugin-api';

export type PlatformToast = {
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
};

export interface PlatformToastApi {
  /** Affiche un toast ; il disparaît seul après 8 s. */
  post(toast: PlatformToast): void;
  /** Pour l'hôte : s'abonner aux toasts publiés. Renvoie la désinscription. */
  subscribe(listener: (toast: PlatformToast & { id: string }) => void): () => void;
}

/**
 * Les modules qui surveillent quelque chose (ArgoCD, pipelines) publient ici ;
 * le socle les affiche (`ToastHost`). Sans socle, `useApi` lève : c'est
 * pourquoi la présence du socle est imposée par profil.
 */
export const platformToastApiRef = createApiRef<PlatformToastApi>({
  id: 'plugin.platform.toasts',
});
